import React from "react";
import { Link } from "react-router-dom";

import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { settingsNavItems } from "@/nav";
import { usePortalConfig } from "@/portal/usePortalConfig";

/** Хаб настроек: карточки секций ЭТОЙ инсталляции.
 *
 * Набор и порядок — из `/api/config.settings_sections`, как и подменю: один
 * реестр на бэкенде, а не `hasPage()` вокруг каждой карточки. */
export function SettingsHubPage(): React.ReactElement {
  const { settings_sections, title } = usePortalConfig();
  const items = settingsNavItems(settings_sections);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Настройки</h1>
        <p className="text-sm text-muted-foreground">{title}</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {items.map((item) =>
          item.error ? (
            // Сломанная секция (см. `settingsNavItems`): видимая ошибка,
            // а не карточка-ссылка — вести пользователя некуда.
            <Card key={item.to + item.label} className="h-full border-destructive">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg text-destructive">
                  <item.icon className="size-5 shrink-0" />
                  {item.label}
                </CardTitle>
              </CardHeader>
            </Card>
          ) : (
            <Link key={item.to} to={item.to} className="block">
              <Card className="h-full transition-colors hover:bg-accent/30">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2 text-lg">
                    <item.icon className="size-5 shrink-0" />
                    {item.label}
                  </CardTitle>
                </CardHeader>
              </Card>
            </Link>
          ),
        )}
      </div>
    </div>
  );
}
